module.exports = __webpack_public_path__ + "_assets/img/stamp.8a49ce2e.svg";